import { render } from "./App.vue?vue&type=template&id=49891962"
const script = {}

import "./App.vue?vue&type=style&index=0&id=49891962&lang=css"
script.render = render

export default script